export const REPORT_TYPES = [
    {
        name: "Simple",
        id: 1,
        type: "state-types-documentDate-receptionDate",
        key: "simple"
    },
    {
        name: "Reporte por Estados",
        id: 2,
        type: "state-documentDate-receptionDate",
        key: "state"
    },
]

export const REPORT_TAX_ANALYSIS_TYPES = [
        {
        name: "Reporte de Análisis Tributario",
        id: 1,
        type: "load_tax",
        key: "load_tax_exel"
    },

]

export const RETENTION_REPORT_TYPES = [
    {
        name: "Reporte por Estados",
        id: 1,
        type: "state-documentDate-receptionDate",
        key: "state"
    },

]

export const RETENTION_NOUSE_TYPES = [
    {
        name: "Reporte por Contabilizar",
        id: 2,
        type: "documentDate-receptionDate",
        key: "retention"
    },
    {
        name: "Reporte Contabilizado",
        id: 3,
        type: "documentDate-receptionDate",
        key: "accounting"
    },
    {
        name: "Reporte RET TOTAL V",
        id: 5,
        type: "documentDate-receptionDate",
        key: "test1"
    },
    {
        name: "Reporte CONTABILIZAR NUEVO",
        id: 6,
        type: "documentDate-receptionDate",
        key: "test2"
    },
]

export const REPORT_CONDITIONS_IDS = [2,4,5,6]
export const RETENTION_REPORT_CONDITIONS_IDS = [2,4,5,6]
export const REPORT_TYPES_IDS = [1,5,6,7,8,9]